<template>
	<div id="hres80x-history-heal-illness1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#historyHealIllness1">
      <h3 class="box-title color-skin">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> {{labels['HRES80XP1']['10']}}
      </h3>
    </div>
    <div id="historyHealIllness1" class="panel-collapse collapse tab-detail collapse in">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <table class="table-1">
            <tr>
              <td class="bg-color-skin text-center" style="width: 5%;">{{labels['HRES80XP1']['30']}}</td>
              <td class="bg-color-skin text-center" style="width: 35%;">{{labels['HRES80XP1']['40']}}</td>
              <td class="bg-color-skin text-center" style="width: 15%;">{{labels['HRES80XP1']['50']}}{{labels['HRES80XP1']['60']}}</td>
              <td class="bg-color-skin text-center" style="width: 15%;">{{labels['HRES80XP1']['70']}}{{labels['HRES80XP1']['80']}}</td>
              <td class="bg-color-skin text-center" style="width: 30%;">{{labels['HRES80XP1']['90']}}</td>
            </tr>
            <!-- 1 -->
            <heal-illness1-detail :numseq="labels['HRES80XP1']['100']"
                                  :description="labels['HRES80XP1']['190']"
                                  :value="dataHisHeal.flgheal1"
                                  :remark="dataHisHeal.remark1" />
            <!-- 2 -->
            <heal-illness1-detail :numseq="labels['HRES80XP1']['110']"
                                  :description="labels['HRES80XP1']['200']"
                                  :value="dataHisHeal.flgheal2"
                                  :remark="dataHisHeal.remark2" />
            <!-- 3 -->
            <heal-illness1-detail :numseq="labels['HRES80XP1']['120']"
                                  :description="labels['HRES80XP1']['210']"
                                  :value="dataHisHeal.flgheal3"
                                  :remark="dataHisHeal.remark3" />
            <!-- 4 -->
            <heal-illness1-detail :numseq="labels['HRES80XP1']['130']"
                                  :description="labels['HRES80XP1']['220']"
                                  :value="dataHisHeal.flgheal4"
                                  :remark="dataHisHeal.remark4" />
            <!-- 5 -->
            <heal-illness1-detail :numseq="labels['HRES80XP1']['140']"
                                  :description="labels['HRES80XP1']['230']"
                                  :value="dataHisHeal.flgheal5"
                                  :remark="dataHisHeal.remark5" />
            <!-- 6 -->
            <heal-illness1-detail :numseq="labels['HRES80XP1']['150']"
                                  :description="labels['HRES80XP1']['240']"
                                  :value="dataHisHeal.flgheal6"
                                  :remark="dataHisHeal.remark6" />
            <!-- 7 -->
            <heal-illness1-detail :numseq="labels['HRES80XP1']['160']"
                                  :description="labels['HRES80XP1']['250']"
                                  :value="dataHisHeal.flgheal7"
                                  :remark="dataHisHeal.remark7" />
            <!-- 8 -->
            <tr>
              <td class="text-center">{{labels['HRES80XP1']['170']}}</td>
              <td colspan="4">{{labels['HRES80XP1']['260']}}</td>
            </tr>
            <tr>
              <td></td>
              <td colspan="5" class="table-2">
                <table>
                  <tr>
                    <td style="width: 24px;"><input type="checkbox" id="flgheal80" :checked="dataHisHeal.flgheal8 === '0'"></td>
                    <td style="width: 280px;">{{labels['HRES80XP1']['270']}}</td>
                    <td style="width: 60px;"></td>
                    <td style="width: 240px;"></td>
                    <td style="width: 60px;"></td>
                  </tr>
                  <tr>
                    <td><input type="checkbox" id="flgheal81" :checked="dataHisHeal.flgheal8 === '1'"></td>
                    <td>{{labels['HRES80XP1']['280']}}</td>
                    <td><input type="text" :value="dataHisHeal.qtysmok" readonly></td>
                    <td colspan="10">{{labels['HRES80XP1']['290']}}</td>
                  </tr>
                  <tr>
                    <td><input type="checkbox" id="flgheal82" :checked="dataHisHeal.flgheal8 === '2'"></td>
                    <td>{{labels['HRES80XP1']['300']}}</td>
                    <td><input type="text" :value="dataHisHeal.qtyyear" readonly></td>
                    <td>{{labels['HRES80XP1']['310']}}</td>
                    <td><input type="text" :value="dataHisHeal.qtymth" readonly></td>
                    <td>{{labels['HRES80XP1']['320']}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>{{labels['HRES80XP1']['330']}}</td>
                    <td><input type="text" :value="dataHisHeal.qtysmok2" readonly></td>
                    <td>{{labels['HRES80XP1']['340']}}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <!-- 9 -->
            <tr>
              <td class="text-center">{{labels['HRES80XP1']['180']}}</td>
              <td colspan="4">{{labels['HRES80XP1']['350']}}</td>
            </tr>
            <tr>
              <td></td>
              <td colspan="5" class="table-2">
                <table>
                  <tr>
                    <td style="width: 24px;"><input type="checkbox" id="flgheal90" :checked="dataHisHeal.flgheal9 === '0'"></td>
                    <td style="width: 280px;">{{labels['HRES80XP1']['360']}}</td>
                    <td style="width: 24px;"><input type="checkbox" id="flgheal91" :checked="dataHisHeal.flgheal9 === '1'"></td>
                    <td colspan="9" style="width: 280px;">{{labels['HRES80XP1']['370']}}</td>
                  </tr>
                  <tr>
                    <td><input type="checkbox" id="flgheal92" :checked="dataHisHeal.flgheal9 === '2'"></td>
                    <td>{{labels['HRES80XP1']['380']}}</td>
                    <td><input type="checkbox" id="flgheal93" :checked="dataHisHeal.flgheal9 === '3'"></td>
                    <td colspan="9">{{labels['HRES80XP1']['390']}}</td>
                  </tr>
                  <tr>
                    <td><input type="checkbox" id="flgheal94" :checked="dataHisHeal.flgheal9 === '4'"></td>
                    <td colspan="11">{{labels['HRES80XP1']['400']}}</td>
                  </tr>
                  <tr>
                    <td><input type="checkbox" id="flgheal95" :checked="dataHisHeal.flgheal9 === '5'"></td>
                    <td>{{labels['HRES80XP1']['410']}}</td>
                    <td style="width: 60px;" colspan="3"><input type="text" :value="dataHisHeal.qtyyear9" readonly></td>
                    <td style="width: 240px;">{{labels['HRES80XP1']['420']}}</td>
                    <td style="width: 60px;"><input type="text" :value="dataHisHeal.qtymth9" readonly></td>
                    <td>{{labels['HRES80XP1']['430']}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
import healIllness1Detail from 'components/hres80x/healIllness1Detail'

export default {
  name: 'hres80x-history-heal-illness1',
  props: [
    'labels',
    'dataHisHeal'
  ],
  components: {
    healIllness1Detail
  }
}
</script>



// WEBPACK FOOTER //
// historyHealIllness1.vue?19fc218d